import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import elementZhTwLocale from 'element-ui/lib/locale/lang/zh-TW'// element-ui lang
import enLocale from './en'
import zhLocale from './zh'
import zhTwLocale from './zh-tw'
import Cookies from 'js-cookie'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  },
  tw: {
    ...zhTwLocale,
    ...elementZhTwLocale
  },
}
var language=navigator.language
//获取当前语言环境，通过后台返回的语言或者浏览器语言环境
export function getLanguage() {
  const chooseLanguage = Cookies.get('language')//取后台设置的语言
  if (chooseLanguage) return chooseLanguage
  //如果后台没有返回语言则根据浏览器的语言环境返回语言变量
  const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  const locales = Object.keys(messages)//获取前端设置的所有语言
  //遍历所有语言值组成的数组，匹配前端设置的语言能匹配到就返回改语言值
  for (const locale of locales) {
      if (language.indexOf(locale) > -1) {
          return locale
      }
  }
  //如果都没匹配到就直接返回英文
  return 'tw'
}
const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: getLanguage(),
  // set locale messages
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js